// src/state/menu/types/hotButtons_types.ts
var HotButtonTypes = /* @__PURE__ */ ((HotButtonTypes2) => {
  HotButtonTypes2["GIFT_CARD"] = "gift-card";
  HotButtonTypes2["CASH_DRAWER"] = "cash-drawer";
  HotButtonTypes2["ID_SCAN"] = "id-scan";
  HotButtonTypes2["CUSTOMERS"] = "customers";
  HotButtonTypes2["OPEN_ITEM"] = "open-item";
  HotButtonTypes2["ITEM"] = "item";
  HotButtonTypes2["MENU_TYPE"] = "menuType";
  HotButtonTypes2["FIRE"] = "fire";
  HotButtonTypes2["MODIFIER_ITEM"] = "modifier-item";
  HotButtonTypes2["NEW_COURSE"] = "new-course";
  HotButtonTypes2["CATEGORY"] = "category";
  HotButtonTypes2["SUBCATEGORY"] = "subcategory";
  HotButtonTypes2["PRINT_CHECKS"] = "print-checks";
  HotButtonTypes2["NONE"] = "none";
  return HotButtonTypes2;
})(HotButtonTypes || {});
var EMPTY_HOT_BUTTON = {
  id: 0,
  position: 0,
  isEmpty: true,
  backgroundColor: null,
  textColor: null,
  bucketId: null,
  type: "none" /* NONE */,
  title: "",
  originalTitle: "",
  wasDeleted: false,
  locationId: null,
  organizationId: 0,
  menuTypeID: null
};

export { EMPTY_HOT_BUTTON, HotButtonTypes };
